﻿import { IComponent, Component, Input, Output, Inject } from "@fiqas/angular-utils";
import { FIQAssist } from "../../app";
import { Severity, Impact } from "../../models/serviceCase";
import { TranslationService } from "../../services/TranslationService";

@Component({
    module: FIQAssist,
    selector: "severityicon",
    template: `<span
                tabindex="0" ng-keydown="$ctrl.onKey($event)" tooltip-class="customTooltipTB" tooltip-placement="bottom" tooltip-append-to-body="true" uib-tooltip="{{$ctrl.severitytext}}"
                class="iconspan {{$ctrl.severityicon}} ng-class:{readonly:$ctrl.readOnly}" ng-click="$ctrl.onClick()"></span>`
})
export class SeverityIcon implements IComponent {
    private _severity: Severity;
    private severityicon: any;
    private severitytext: string;
    private initialized: boolean = false;

    private newdown: boolean;
    private newworkaround: boolean;
    private newimpact: Impact;
    private newseverity: Severity;
    public severityChanged: boolean = false;

    constructor(
        @Inject('$uibModal') private $modal: angular.ui.bootstrap.IModalService,
        @Inject() private translationService: TranslationService
    ) { }

    @Input() public get readOnly() {
        return !this.editable;
    }
    public set readOnly(val: boolean) {
        this.editable = !val;
    }

    @Input()
    get severity(): Severity {
        return this._severity;
    }
    set severity(level: Severity) {
        this._severity = level;
        this.makeSeverityIcon();
    }

    @Input() public isprod: boolean;
    @Input() public editable: boolean;
    @Input() public down: boolean;
    @Input() public impact: Impact;
    @Input() public workaround: boolean;

    @Output() public onseveritychanged: (args: { severity: Severity, down: boolean, workaround: boolean; impact: Impact }) => void;

    $onInit() {
        this.initialized = true;
        if (!this.severityicon)
            this.makeSeverityIcon();
    }

    private severityicons: { key: string, nr: number, text: string, icon: string }[] = [
        { key: 'level1', nr: 1, text: 'MTTR_HOURS', icon: 'icon-sev1' },
        { key: 'level2', nr: 2, text: 'MTTR_DAYS', icon: 'icon-sev2' },
        { key: 'level3', nr: 3, text: 'MTTR_WEEKS', icon: 'icon-sev3' },
        { key: 'level4', nr: 4, text: 'MTTR_NEXT_RELEASE', icon: 'icon-sev4' },
    ];
    private makeSeverityIcon() {
        if (this.initialized) {
            let i = this.severityicons.filter(s => s.key == this._severity).shift();
            this.severitytext = i ? `Severity ${i.nr} - ${this.translationService.Translate(i.text)}` : "";
            this.severityicon = i ? i.icon : null;
        }
    }

    public OnSeverityChanged(severity: Severity, down: boolean, workaround: boolean, impact: Impact) {
        this.newseverity = severity;
        this.newdown = down;
        this.newworkaround = workaround;
        this.newimpact = impact;
        this.severityChanged = true;
    }

    private saveSeverity() {
        if (this.severityChanged) {
            this.onseveritychanged({ severity: this.newseverity, down: this.newdown, workaround: this.newworkaround, impact: this.newimpact });
        }
    }

    private async onClick() {
        try {
            let result = await this.$modal.open({
                controller: SeverityModelController,
                controllerAs: '$ctrl',
                templateUrl: '/views/severitypopup.html',
                resolve: {
                    parentIcon: () => this,
                    readOnly: () => !this.editable
                }
            }).result;
            if (result)
                this.saveSeverity();
        } catch (_) {

        }
    }

    private onKey($event: KeyboardEvent) {
        switch ($event.keyCode) {
            case 13: //cr
                $event.preventDefault();
                if (this.editable) {
                    this.saveSeverity();
                }
                break;
            case 27: //esc
                $event.preventDefault();
                this.editable = false;
                break;

            case 32: //space
                $event.preventDefault();
                this.onClick();
                break;
        }
    }
}
class SeverityModelController {
    constructor(
        @Inject('parentIcon') private parentIcon: SeverityIcon,
        @Inject('readOnly') private readOnly: boolean,
        @Inject('$uibModalInstance') private $modalInstance: angular.ui.bootstrap.IModalServiceInstance
    ) { }
    public get isprod() { return this.parentIcon.isprod; }
    public get severity() { return this.parentIcon.severity; }
    public get down() { return this.parentIcon.down; }
    public get impact() { return this.parentIcon.impact; }
    public get workaround() { return this.parentIcon.workaround; }
    public get severityChanged() { return this.parentIcon.severityChanged; }
    public OnSeverityChanged = (severity: Severity, down: boolean, workaround: boolean, impact: Impact) => this.parentIcon.OnSeverityChanged(severity, down, workaround, impact);
    public Cancel = () => this.$modalInstance.close(false);
    public Save = () => this.$modalInstance.close(true);
}
